module.exports = __webpack_public_path__ + "static/media/windshield.fbef5530.jpg";